module.exports = __webpack_public_path__ + "static-v-shop/1785501885960/img/cristal-ojo-izquierdo.658324f8.png";